module.exports = __webpack_public_path__ + "img/top.19cf0f86.svg";